/**
 * @author       justin.jeong@zumper.com (Justin Jeong)
 * @copyright    Copyright (c) 2019, Zumper
 * @description  offline action middleware
 */

import { selectIsBot, selectIsOnline } from '@zcode-ui/web-zumper-global-state'
import { ON_SERVER } from '../../env'
import { REQUEUE } from './constants'

const createOfflineMiddleware = () => {
  const offlineQueue = []
  const offlineSet = new Set()
  return (store) => (next) => (action) => {
    const { getState } = store
    const state = getState()
    const isBot = selectIsBot(state)
    const result = next(action)
    const { type, payload } = action

    if (ON_SERVER || isBot) {
      return result
    }

    const isOnline = selectIsOnline(state)
    if (type === REQUEUE) {
      const { callback, options, name } = payload
      if (!offlineSet.has(name)) {
        offlineQueue.push({ callback, options, queuedAt: Date.now(), name })
        offlineSet.add(name)
      }
    } else if (isOnline && offlineQueue.length > 0) {
      const now = Date.now()
      while (offlineQueue.length > 0) {
        const { callback, options, queuedAt, name } = offlineQueue.shift()
        const { before } = options
        if ((!before || now - queuedAt < before) && window) {
          window.requestIdleCallback(callback)
          offlineSet.delete(name)
        }
      }
    }
    return result
  }
}

export default createOfflineMiddleware
